import { useEffect, useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const CACHE_KEY = 'site_favicon_url';

const DynamicFavicon = () => {
  const [faviconUrl, setFaviconUrl] = useState(() => {
    // Load from cache immediately for instant display
    try {
      return localStorage.getItem(CACHE_KEY) || null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    // Fetch fresh settings
    fetch(`${BACKEND_URL}/api/site-settings`)
      .then(res => res.json())
      .then(data => {
        let url = data.favicon || data.logo_header;
        
        if (url) {
          // Add BACKEND_URL if it's a relative path
          if (url.startsWith('/')) {
            url = `${BACKEND_URL}${url}`;
          }
          
          // Cache for instant load next time
          try {
            localStorage.setItem(CACHE_KEY, url);
          } catch {}
          
          setFaviconUrl(url);
        }

        // Update page title if available
        if (data.logo_alt) {
          document.title = data.logo_alt;
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!faviconUrl) return;

    // Update the existing favicon elements (created in index.html)
    const iconElement = document.getElementById('dynamic-favicon');
    const appleElement = document.getElementById('dynamic-apple-icon');
    
    if (iconElement) {
      iconElement.href = faviconUrl;
    }
    
    if (appleElement) {
      appleElement.href = faviconUrl;
    }

    // Also update/create shortcut icon for older browsers
    let shortcutIcon = document.querySelector('link[rel="shortcut icon"]');
    if (!shortcutIcon) {
      shortcutIcon = document.createElement('link');
      shortcutIcon.rel = 'shortcut icon';
      document.head.appendChild(shortcutIcon);
    }
    shortcutIcon.href = faviconUrl;

  }, [faviconUrl]);

  return null;
};

export default DynamicFavicon;
